import { useState, useCallback } from "react";
import { MapPin, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useConfig } from "./ConfiguracoesLayout";
import ConfigSection, { inputClass } from "./ConfigSection";
import { fetchCep, formatCep } from "@/lib/cep-utils";

const Endereco = () => {
  const { form, update, toast } = useConfig();
  const [cepLoading, setCepLoading] = useState(false);

  const handleCepChange = useCallback(async (raw: string) => {
    const formatted = formatCep(raw);
    update("address_zip", formatted);

    const digits = raw.replace(/\D/g, "");
    if (digits.length === 8) {
      setCepLoading(true);
      const data = await fetchCep(digits);
      setCepLoading(false);
      if (data) {
        update("address_street", data.logradouro || form.address_street);
        update("address_neighborhood", data.bairro || form.address_neighborhood);
        update("address_city", data.localidade || form.address_city);
        update("address_state", data.uf || form.address_state);
        toast({ title: "CEP encontrado!", description: `${data.logradouro}, ${data.localidade} - ${data.uf}` });
      } else {
        toast({ title: "CEP não encontrado", description: "Verifique o CEP e tente novamente.", variant: "destructive" });
      }
    }
  }, [update, form, toast]);

  return (
    <ConfigSection title="Endereço" icon={MapPin}>
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2 col-span-1">
          <Label>CEP</Label>
          <div className="relative">
            <Input
              value={form.address_zip}
              onChange={(e) => handleCepChange(e.target.value)}
              className={inputClass}
              placeholder="00000-000"
              maxLength={9}
            />
            {cepLoading && (
              <Loader2 className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 animate-spin text-muted-foreground" />
            )}
          </div>
        </div>
        <div className="space-y-2 col-span-2">
          <Label>Rua</Label>
          <Input value={form.address_street} onChange={(e) => update("address_street", e.target.value)} className={inputClass} />
        </div>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label>Número</Label>
          <Input value={form.address_number} onChange={(e) => update("address_number", e.target.value)} className={inputClass} />
        </div>
        <div className="space-y-2">
          <Label>Bairro</Label>
          <Input value={form.address_neighborhood} onChange={(e) => update("address_neighborhood", e.target.value)} className={inputClass} />
        </div>
        <div className="space-y-2">
          <Label>Cidade</Label>
          <Input value={form.address_city} onChange={(e) => update("address_city", e.target.value)} className={inputClass} />
        </div>
      </div>
      <div className="space-y-2 w-1/3">
        <Label>Estado</Label>
        <Input value={form.address_state} onChange={(e) => update("address_state", e.target.value)} className={inputClass} placeholder="SP" maxLength={2} />
      </div>
    </ConfigSection>
  );
};

export default Endereco;
